import Client from "./client";

const baseUrl = `/api/1/withdrawals`;

function withdrawal() {
  return {
    create: withdrawalReqDto => {
      return Client.post(baseUrl, withdrawalReqDto);
    },
    getAllMyWithdrawals: (pageSize, pageNumber) => {
      return Client.get(baseUrl + `/self/${pageSize}/${pageNumber}`);
    },
    getMyWithdrawals: (currency, pageSize, pageNumber) => {
      return Client.get(
        baseUrl + `/self/${currency}/${pageSize}/${pageNumber}`
      );
    },
    confirmWithdrawalPost: dto => {
      return Client.post(baseUrl + `/confirm`);
    },

    confirmWithdrawal: params => {
      return Client.get(baseUrl + `/${params.id}/confirm/${params.token}`);
    },
    cancelWithdrawal: id => {
      return Client.delete(baseUrl + `/cancel/${id}`);
    },
    resendWithdrawalMail: id => {
      return Client.get(baseUrl + `/resendMail/${id}`);
    }
  };
}

export default withdrawal();
